import { Logger } from '../utils/logger';
import { DomUtils } from '../utils/dom-utils';
import { AjaxService } from '../services/ajax-service';
export class AbstractContentLoader {
    constructor(ajaxUrl, nonce, postId, formId, contentId) {
        this.ajaxService = new AjaxService(ajaxUrl, nonce);
        this.postId =
            typeof postId === 'string' ? parseInt(postId, 10) : postId;
        this.formId =
            typeof formId === 'string' ? parseInt(formId, 10) : formId;
        this.contentId = contentId;
    }
    /**
     * Show loading message
     * @param message
     */
    showLoading(message) {
        const loadingContainer = this.getLoadingContainer();
        DomUtils.showElement(loadingContainer, `<p>${message}</p>`);
    }
    /**
     * Hide loading message
     */
    hideLoading() {
        const loadingContainer = this.getLoadingContainer();
        DomUtils.hideElement(loadingContainer);
    }
    /**
     * Show error message
     * @param message
     */
    showError(message) {
        const formContainer = this.getFormContainer();
        DomUtils.showElement(formContainer, `<p>${message}</p>`);
    }
    /**
     * Handle AJAX errors
     * @param error
     * @param context
     */
    handleAjaxError(error, context) {
        Logger.error(`AJAX error in ${context}`, error);
        this.hideLoading();
        this.showError('Error loading content. Please refresh the page.');
    }
}
